/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import React from "react";

// Zaim engineering components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { IconButton, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";

export default function buildComboTable(data, onEdit, canUpdate = true) {
  const Product = ({ name, code }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{code}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "product", accessor: "product", width: "45%", align: "left" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "Total Product", accessor: "totalProduct", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    const stockStatus = item.totalQuantity <= item.minStockQty ? "Low stock" : "In stock";
    const statusColor = stockStatus === "Low stock" ? "error" : "success";

    return {
      product: <Product name={item.name} code={item.shortName} />,
      status: (
        <MDBox ml={-1}>
          <MDBadge badgeContent={stockStatus} color={statusColor} variant="gradient" size="sm" />
        </MDBox>
      ),
      totalProduct: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.products.length}
        </MDTypography>
      ),
      action: canUpdate ? (
        <Tooltip title="Edit">
          <IconButton
            color="info"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item.id);
            }}
          >
            <EditNoteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <MDTypography variant="caption" color="text">
          —
        </MDTypography>
      ),
    };
  });

  return { columns, rows };
}
